import { render, staticRenderFns } from "./AdiPuaList.vue?vue&type=template&id=2725bcb8"
import script from "./AdiPuaList.vue?vue&type=script&lang=js"
export * from "./AdiPuaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports